import { render, staticRenderFns } from "./F-1-1__ADATA-member-info_RegisterProducts.vue?vue&type=template&id=38a6b566&scoped=true&"
import script from "./F-1-1__ADATA-member-info_RegisterProducts.vue?vue&type=script&lang=js&"
export * from "./F-1-1__ADATA-member-info_RegisterProducts.vue?vue&type=script&lang=js&"
import style0 from "./F-1-1__ADATA-member-info_RegisterProducts.vue?vue&type=style&index=0&id=38a6b566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a6b566",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
